export default __webpack_public_path__ + "static/media/bieltcmmontyfb.18ccb757.jpg";